import React, { useContext, useEffect, useRef } from 'react';
import AllocationTable from '../AllocationTable/AllocationTable';
import { handleStickyHeader } from './util';
import { CartContext } from '../../context/CartContext/CartContext';
import useCartDetailsState from '../../hooks/useCartDetailsState';
import PortfolioAllocation from '../PortfolioAllocation/PortfolioAllocation';
import AllocationHeader from '../AllocationHeader/AllocationHeader';
import styles from './style.css';
import { FlowContext } from '../../core/flow-engine';
import {
  changeMinimumInvestment,
  decideFundMinimumProperty
} from '../../flows/shared/utils';

export default ({
  filterOpen,
  headerOpen,
  toggleHeader,
  rewardsAvailable = { closedFunds: false, iClassFunds: false }
}) => {
  const wrapperRef = useRef(null);
  const cartState = useContext(CartContext);
  const { appState, flowProps } = useContext(FlowContext);
  const {
    store: { accountType }
  } = appState;
  const { fundMinimum } = flowProps;

  useEffect(() => {
    const scrollHandler = handleStickyHeader(wrapperRef);

    window.addEventListener('scroll', scrollHandler, {
      capture: true,
      passive: true
    });

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (filterOpen) toggleHeader(false);
  }, [filterOpen]);

  const { selectedFunds, totalAmount, data = {} } = cartState;
  const { mutualFunds = [] } = data;

  // TODO: create an option to retrieve fund minimums
  // by UGMAUTMA account type on the server side
  // so we don't have to mutate data in the UI
  const mutualFundsWithAllocations = changeMinimumInvestment(
    mutualFunds,
    fundMinimum
  );

  const {
    validCart,
    validTaxableCart,
    totalAllocationsValid,
    fundsWithCategories,
    categoryTotals: { overallBonds, overallStocks, overallShortTerm }
  } = useCartDetailsState({
    selectedFunds,
    mutualFundsWithAllocations,
    rewardsAvailable,
    totalAmount
  });

  const validCartForFlow = decideFundMinimumProperty(
    accountType,
    !validCart,
    !validTaxableCart
  );

  return (
    <div className="allocation-section" ref={wrapperRef}>
      <div className="allocation-header">
        <AllocationHeader
          headerOpen={headerOpen}
          toggleHeader={toggleHeader}
          disabled={validCartForFlow}
          fundsWithCategories={fundsWithCategories}
          shoppingCartEmpty={!fundsWithCategories.length}
        />
      </div>
      {headerOpen && (
        <div className="allocation-contents">
          <div className="mobile-chart">
            <PortfolioAllocation
              shoppingCartEmpty={!fundsWithCategories.length}
              stocks={overallStocks}
              bonds={overallBonds}
              shortTerm={overallShortTerm}
            />
          </div>
          <div className="table">
            <AllocationTable
              fundsWithCategories={fundsWithCategories}
              shoppingCartEmpty={!fundsWithCategories.length}
              rewardsAvailable={rewardsAvailable}
            />
          </div>
          {totalAllocationsValid && (
            <div className="chart">
              <PortfolioAllocation
                shoppingCartEmpty={!fundsWithCategories.length}
                stocks={overallStocks}
                bonds={overallBonds}
                shortTerm={overallShortTerm}
              />
            </div>
          )}
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};
